import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
    tripItemRow1: {

    },
    dottedLine: {
        borderLeft: '2.7px dashed',
        borderColor: 'rgb(255, 211, 40)',
        marginLeft: '4.66px',
        marginTop: '3px',
        height: '75%',
    },
    viewDetailLink: {
        fontSize: 16,
        fontWeight: 500,
    },
    cardWrapper: {
        borderRadius: theme.typography.pxToRem(15),
        overflow: 'hidden',
        maxWidth: theme.typography.pxToRem(330),
        minWidth: theme.typography.pxToRem(300),
        maxHeight: 'calc(100vh - 187px)',
        overflowY: 'auto'
    },
    tripItem: {
        padding: theme.spacing(4, 3, 2, 3),
    },
    tripItemSelected: {
        backgroundColor: 'rgba(255,212,40,.10)'
    },
    tripItemRow: {
        display: 'flex'
    },
    tripItemIconBox: {
        marginTop: theme.typography.pxToRem(2)
    },
    tripItemIconStart: {
        width: theme.typography.pxToRem(12),
        height: theme.typography.pxToRem(12),
        background: 'rgb(255,214,67)',
        borderRadius: theme.typography.pxToRem(12),
    },
    tripItemIconEnd: {
        width: theme.typography.pxToRem(12),
        height: theme.typography.pxToRem(12),
        background: 'rgb(255,214,67)'
    },
    tripItemSideBox: {
        padding: theme.spacing(0, 0, 1, 1)
    },
    eventAddress: {
        fontSize: theme.typography.pxToRem(12),
        fontWeight: 700,
        color: 'black'
    },
    eventNoAddress: {
        fontSize: theme.typography.pxToRem(12),
        fontWeight: 700,
        color: 'rgb(177,177,177)'
    },
    eventDate: {
        fontSize: theme.typography.pxToRem(10),
        color: 'rgb(177,177,177)',
        padding: theme.spacing(0.6, 0, 0, 0)
    },
    dividerClass: {
        margin: theme.spacing(2, 0, 2, 0)
    },
    stateBoxContainer: {

    },
    stateBoxContainerItem: {
        flex: 1,
        padding: theme.spacing(0, 2)
    },
    stateTitle: {
        fontSize: theme.typography.pxToRem(10),
        color: 'rgb(177,177,177)'
    },
    stateValue: {
        fontSize: theme.typography.pxToRem(12),
        color: 'rgb(0,0,0)'
    },
    eventBox: {
        padding: theme.spacing(1, 0, 1, 0)
    },
    eventsIcon: {
        height: theme.typography.pxToRem(25),
        width: theme.typography.pxToRem(25),
    },
    eventValue: {
        margin: theme.spacing(0, 0, 0, 2),
        fontSize: theme.typography.pxToRem(20),
        fontWeight: 500
    },
    tripCardPopUpCloseButton: {
        position: 'absolute',
        right: '0',
        top: '0',
        zIndex: 1,
        cursor: 'pointer'
    },
    driverLocatorExpandButton: {
        position: 'absolute',
        right: '0',
        top: '0',
        zIndex: 1,
        cursor: 'pointer'
    },

    // stateDate: {
    //     color: 'rgb(175, 179, 187)',
    //     marginBottom: 4,
    //     fontSize: 10,
    // },
    // locationLabelCircle: {
    //     width: "18px",
    //     margin: "-5px 5px 0 0",
    // },
    // colorLocationCircle: {
    //     color: "rgb(255,214,67)",
    // },

    // cardWrapper: {
    //     borderRadius: "24px",
    //     width: 360,
    //     padding: "32px",
    //     // backgroundColor: '#fff',
    //     display: 'flex',
    //     flexDirection: 'column',
    //     // alignItems: 'center',
    //     justifyContent: 'center'

    // },

    // disabledText: {
    //     fontSize: '14px',
    //     fontWeight: 400,
    //     color: '#bfbfbf',
    //     textAlign: 'center'
    // },

    // cardHeaderWrapper: {
    //     display: 'flex',
    //     alignItems: 'center',
    //     justifyContent: 'center'
    // },

    // headerTitle: {
    //     fontSize: "20px",
    //     fontWeight: 900,
    //     marginBottom: 10,
    //     marginLeft: 10
    // },

    // driverName: {
    //     fontSize: 18,
    //     fontWeight: 700,
    //     margin: '32px 0px',
    //     // textAlign: 'center',
    //     // borderBottom: '3px solid #ffd328',
    //     padding: "4px 8px",
    // },
    // driverDetailWrapper: {
    //     display: 'flex',
    //     flexDirection: 'row',
    //     marginBottom: 32,
    // },
    // driverLocation: {
    //     fontSize: 12,
    //     fontWeight: 700,
    //     marginBottom: 4
    // },
    // cardInfo: {
    //     fontSize: "18px",
    //     fontWeight: 700,
    // },
    // driverDistance: {
    //     fontSize: 12,
    //     fontWeight: 700,
    //     marginBottom: 4
    // },
    // cardInfoUl: {
    //     fontSize: "14px",
    //     fontWeight: 700,
    //     borderBottom: '3px solid #ffd328',
    //     padding: "4px 4px",

    // },
    // viewDetailLink: {
    //     fontSize: 16,
    //     fontWeight: 200,
    // },

    // cardInfoDisabled: {
    //     fontSize: '12px',
    //     color: '#b1b1b1',
    //     fontWeight: 400,
    // },

    // scoreContainer: {
    //     display: 'flex',
    //     alignItems: 'center',
    //     justifyContent: 'center',
    //     flexDirection: 'row'
    // },
    // scoreWrapper: {
    //     margin: "0px 16px"
    // },

    // eventsContainer: {
    //     display: 'flex',
    //     alignItems: 'right',
    //     justifyContent: 'center',
    //     flexDirection: 'row'
    // },
    // eventsWrapper: {
    //     margin: "0px 8px"
    // },

    // eventsIcon: {
    //     margin: "0 16px 0 0",
    //     height:"24px",
    //     width:'24px'
    // },

    // imageIcon: {
    //     margin: "0 0.5em",
    // },

    // dividerContainer: {
    //     width: '100%',
    //     margin: '16px 0px'
    // },

    // description: {
    //     color: 'rgb(175, 179, 187)',
    //     marginBottom: 4
    // },

    // driverDetailWrapper: {
    //     display: 'flex',
    //     flexDirection: 'row',
    //     marginBottom: 4,
    // },

    // userIconSrapper: {
    //     marginRight: 24
    // },

    // headerSubTitle: {
    //     fontSize: "15px",
    //     color: "#8a8a8a",
    //     marginLeft: 10
    // },

    // dragDrop: {
    //     display: "flex",
    //     flexDirection: 'row',
    // },
    // dragdropComponent: {
    //     display: 'flex',
    //     flexDirection: "row",
    //     width: '100%',
    //     borderTop: "rgb(241,242,246) solid 2px"
    // },
    // columns: {
    //     display: 'flex',
    //     flexDirection: 'column',
    //     textAlign: 'center',
    //     justifyContent: 'space-between',
    //     padding: 20,
    //     width: "350px",
    //     // backgroundColor:"#f1f2f6",
    // },
    // colName: {
    //     color: "#848484",
    //     fontWeight: 500,
    //     fontSize: "14px"
    // },

}));


